var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            visible: _vm.isShowHint,
            center: "",
            title: "提示",
            top: "30vh",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowHint = $event
            },
          },
        },
        [
          _c("div", [
            _c("div", { staticStyle: { "margin-bottom": "30px" } }, [
              _vm._v("\n\t\t\t\t您本次批增起保日期为\n\t\t\t\t"),
              _c("span", { staticClass: "red-bold" }, [
                _vm._v(_vm._s(_vm.lastTimeData[0])),
              ]),
              _vm._v("\n\t\t\t\t，受保司规则限制，此后在\n\t\t\t\t"),
              _c("span", { staticClass: "red-bold" }, [
                _vm._v(_vm._s(_vm.lastTimeData[1])),
              ]),
              _vm._v("\n\t\t\t\t前本保单再批增起保日期将不得早于\n\t\t\t\t"),
              _c("span", { staticClass: "red-bold" }, [
                _vm._v(_vm._s(_vm.lastTimeData[0])),
              ]),
              _vm._v("\n\t\t\t\t，请确认是否继续批增？\n\t\t\t"),
            ]),
            _c(
              "div",
              { staticStyle: { display: "flex", "justify-content": "center" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      disabled: _vm.currentDelayTime !== 0,
                      type: "primary",
                    },
                    on: { click: _vm.onSure },
                  },
                  [
                    _vm._v("\n\t\t\t\t\t我已悉知批增起保规则\n\t\t\t\t\t"),
                    _vm.currentDelayTime !== 0
                      ? _c("span", [
                          _vm._v("（" + _vm._s(_vm.currentDelayTime) + "）"),
                        ])
                      : _vm._e(),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }